const script = document.currentScript || document.querySelector('[data-hd-image-protection]');
const config = {
  enabled: script?.dataset.enabled === 'true',
  toastEnabled: script?.dataset.toastEnabled === 'true',
  message: script?.dataset.message || "Product images are protected by Hustler's Drip",
};

const PROTECTOR_SELECTOR = '[data-hd-image-protect]';
const INPUT_SELECTOR = 'input, textarea, select, [contenteditable="true"]';
let toastElement = null;
let toastTimer = 0;

function getProtectedSurface(target) {
  if (!(target instanceof Element)) return null;
  if (target.closest(INPUT_SELECTOR)) return null;
  return target.closest(PROTECTOR_SELECTOR);
}

function ensureToast() {
  if (toastElement || !config.toastEnabled) return toastElement;

  toastElement = document.createElement('div');
  toastElement.className = 'hd-image-protection-toast';
  toastElement.setAttribute('role', 'status');
  toastElement.setAttribute('aria-live', 'polite');
  toastElement.textContent = config.message;
  document.body.appendChild(toastElement);

  return toastElement;
}

function showToast() {
  const toast = ensureToast();
  if (!toast) return;

  toast.textContent = config.message;
  window.clearTimeout(toastTimer);
  toast.classList.add('is-visible');

  toastTimer = window.setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 1800);
}

function protectImages(root = document) {
  if (!config.enabled) return;
  const scope = root instanceof Element || root instanceof Document ? root : document;

  scope.querySelectorAll(PROTECTOR_SELECTOR).forEach((surface) => {
    surface.dataset.hdImageProtectReady = 'true';
    surface.querySelectorAll('img').forEach((image) => {
      image.setAttribute('draggable', 'false');
      image.dataset.hdImageProtected = 'true';
    });
  });
}

function handleContextMenu(event) {
  if (!config.enabled) return;
  const protectedSurface = getProtectedSurface(event.target);
  if (!protectedSurface) return;

  event.preventDefault();
  showToast();
}

function handleDragStart(event) {
  if (!config.enabled) return;
  const protectedSurface = getProtectedSurface(event.target);
  if (!protectedSurface) return;

  event.preventDefault();
  showToast();
}

function initImageProtection() {
  if (!config.enabled) return;

  protectImages();
  document.addEventListener('contextmenu', handleContextMenu, true);
  document.addEventListener('dragstart', handleDragStart, true);
  document.addEventListener('shopify:section:load', (event) => protectImages(event.target));
  document.addEventListener('shopify:section:reorder', (event) => protectImages(event.target));
  document.addEventListener('hd:cart:updated', () => protectImages());
  document.addEventListener('hd:quick-add:updated', () => protectImages());

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) {
          if (node.matches(PROTECTOR_SELECTOR) || node.querySelector(PROTECTOR_SELECTOR)) {
            protectImages(node);
          }
        }
      });
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initImageProtection, { once: true });
} else {
  initImageProtection();
}
